import React, { ReactNode } from 'react';

export type WealthKpi = {
  key: string;
  label: string;
  value: ReactNode;
  /** Small line under the value (change, account count, date). */
  detail?: ReactNode;
  tone?: 'gain' | 'loss';
};

export type WealthKpiStripProps = {
  items: WealthKpi[];
};

/** Row of headline figures above the wealth chart (rework board Main). */
const WealthKpiStrip: React.FC<WealthKpiStripProps> = ({ items }) => (
  <section className="wealth-kpi-strip" aria-label="Summary">
    {items.map((item) => (
      <div className="wealth-kpi" key={item.key}>
        <span className="wealth-kpi-label">{item.label}</span>
        <span className={`wealth-kpi-value${item.tone ? ` is-${item.tone}` : ''}`}>
          {item.value}
        </span>
        {item.detail ? <small className="wealth-kpi-detail">{item.detail}</small> : null}
      </div>
    ))}
  </section>
);

export default WealthKpiStrip;
